export const AUTH_ERROR_TYPES = {
  // Backend sets this when a user's FactSet product entitlements are revoked
  identityLocked: 'identity_locked',
  notConfigured: 'not_configured',
}
